import React from 'react';
import { SecurityHeaders } from './SecurityHeaders';
import { PerformanceOptimizations } from '../performance/PerformanceOptimizations';

interface WebsiteSecurityProviderProps {
  children: React.ReactNode;
}

export const WebsiteSecurityProvider: React.FC<WebsiteSecurityProviderProps> = ({ 
  children 
}) => {
  return (
    <>
      <SecurityHeaders />
      <PerformanceOptimizations />
      {children}
    </>
  );
};